/**
 * The passenger ID-proof type dropdown — booking wizard AND voucher/invoice
 * passenger rows, one shared list so the two screens never drift apart on
 * spelling.
 *
 * `idType` ITSELF STAYS A FREE-TEXT COLUMN, not an enum — this list is a UI
 * affordance over it, not a schema constraint. Choosing one of the first five
 * stores exactly that string; choosing "Other" reveals a plain text box whose
 * typed value is what gets stored (never the literal word "Other"). Existing
 * free-text rows (legacy data, or a custom "Other" value typed before this
 * list existed) are never rewritten — see `displayIdType` below for how they
 * are shown without touching what is stored.
 */
export const ID_PROOF_TYPES = ['Aadhaar', 'Passport', 'Voter ID', 'Driving Licence', 'PAN', 'Other'];
export function isKnownIdProofType(value) {
    return ID_PROOF_TYPES.includes(value) && value !== 'Other';
}
/**
 * Case/spelling variants seen in data entered before this dropdown existed —
 * mapped to the canonical label for DISPLAY ONLY. The stored `idType` value
 * is never rewritten by this function or by anything that calls it; a legacy
 * row keeps whatever string it has, forever.
 */
const LEGACY_DISPLAY_ALIASES = {
    aadhar: 'Aadhaar',
    'aadhar card': 'Aadhaar',
    'adhar card': 'Aadhaar',
    adhar: 'Aadhaar',
    aadhaar: 'Aadhaar',
    'aadhaar card': 'Aadhaar',
    passport: 'Passport',
    'voter id': 'Voter ID',
    'voter card': 'Voter ID',
    'voter id card': 'Voter ID',
    'driving licence': 'Driving Licence',
    'driving license': 'Driving Licence',
    dl: 'Driving Licence',
    pan: 'PAN',
    'pan card': 'PAN',
};
/**
 * What to SHOW for a stored `idType` — the canonical label when the raw
 * value is a known one of the six, a mapped legacy spelling, or (the
 * ordinary case for anything else, including a genuine "Other" entry) the
 * raw value itself, verbatim.
 */
export function displayIdType(raw) {
    const trimmed = (raw ?? '').trim();
    if (trimmed.length === 0)
        return '';
    if (ID_PROOF_TYPES.includes(trimmed))
        return trimmed;
    return LEGACY_DISPLAY_ALIASES[trimmed.toLowerCase()] ?? trimmed;
}
//# sourceMappingURL=id-proof.js.map